import { render } from "./BrinkTwo.vue?vue&type=template&id=6848c91b"
import script from "./BrinkTwo.vue?vue&type=script&lang=js"
export * from "./BrinkTwo.vue?vue&type=script&lang=js"

import "./BrinkTwo.vue?vue&type=style&index=0&id=6848c91b&lang=css"
script.render = render

export default script